import { render, staticRenderFns } from "./performanceTodo.vue?vue&type=template&id=5823732d&"
import script from "./performanceTodo.vue?vue&type=script&lang=js&"
export * from "./performanceTodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5823732d')) {
      api.createRecord('5823732d', component.options)
    } else {
      api.reload('5823732d', component.options)
    }
    module.hot.accept("./performanceTodo.vue?vue&type=template&id=5823732d&", function () {
      api.rerender('5823732d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/PL/components/performanceTodo.vue"
export default component.exports